import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import { makeStyles } from '../../../tools/makeStyles';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { defaultDescription, defaultTitle } from '../constants/constants';
import Header from '../common/Header.jsx';
import Footer from '../common/Footer.jsx';
import { setTabIndex } from '../../helpers/accessibility_helper';
import { DEFAULT_TRANSLATION } from '../../helpers/constants';

const useStyles = makeStyles(() => ({
  textContainer: {
    width: '100%',
  },
}));

const TextPreview = ({
  handleAnswer = () => {},
  savedAnswer,
  showSkipButton = false,
  questionId = -1,
  isRequired = false,
  showDescription = false,
  title = defaultTitle,
  titleRef,
  titleAriaLabel,
  commentAriaLabel,
  description = defaultDescription,
  placeholder = 'Enter your response here...',
  isActive = true,
  translation = DEFAULT_TRANSLATION,
}) => {
  const styles = useStyles();

  const emptyAnswer = { value: '', questionId };
  const [answer, setAnswer] = useState(savedAnswer || emptyAnswer);

  const handleOnChange = (event) => {
    const newAnswer = { ...answer, value: event.target.value };
    setAnswer(newAnswer);
  };

  const onBlur = () => handleAnswer(answer, false);

  const onConfirm = (hasAnswer = false) => {
    if (hasAnswer) {
      handleAnswer(answer);
    } else {
      setAnswer(emptyAnswer);
      handleAnswer(emptyAnswer);
    }
  };

  return (
    <div>
      <Header
        isRequired={isRequired}
        title={title}
        titleRef={titleRef}
        titleAriaLabel={titleAriaLabel}
        description={description}
        showDescription={showDescription}
        isActive={isActive}
        questionId={questionId}
        translation={translation}
      />

      <div className={classNames(styles.textContainer)}>
        <TextField
          inputProps={{
            tabIndex: setTabIndex(isActive),
            'aria-hidden': !isActive,
            'aria-label': commentAriaLabel,
          }}
          fullWidth
          multiline
          value={answer.value}
          onChange={handleOnChange}
          onBlur={onBlur}
          variant="outlined"
          rows="4"
          placeholder={placeholder}
        />
      </div>

      <Footer
        showSkipButton={showSkipButton && answer.value === ''}
        showOkButton={answer.value !== ''}
        onConfirm={onConfirm}
        isActive={isActive}
        translation={translation}
      />
    </div>
  );
};

TextPreview.propTypes = {
  questionId: PropTypes.number,
  title: PropTypes.string,
  description: PropTypes.string,
  placeholder: PropTypes.string,
  savedAnswer: PropTypes.object,
  handleAnswer: PropTypes.func,
  showSkipButton: PropTypes.bool,
  showDescription: PropTypes.bool,
  isRequired: PropTypes.bool,
  isActive: PropTypes.bool,
};

export default TextPreview;
